import type { ErrorDefinition } from './types';

/**
 * Shared error definitions for AI-grading failures returned by Claude-backed
 * endpoints (`/api/grade`, `/api/test/{id}/complete`). Reused by both
 * onboarding and mock-interview error maps so the AI wording stays consistent.
 */
export const AI_ERRORS: Record<string, ErrorDefinition> = {
  AI_RATE_LIMITED: {
    title: 'Please wait',
    message: 'Our grading service is busy right now.',
    action: 'Try again in a moment.',
    retryable: true,
    retryAfterSeconds: 5,
    category: 'rate_limit',
  },

  AI_UNAVAILABLE: {
    title: 'Service unavailable',
    message: 'Answer checking is temporarily unavailable.',
    action: 'Please try again in a few moments.',
    retryable: true,
    retryAfterSeconds: 30,
    category: 'server',
  },

  AI_SERVICE_ERROR: {
    title: 'Grading failed',
    message:
      "We couldn't check your answer. We've been notified and are looking into it.",
    action: 'Please try again in a moment.',
    retryable: true,
    category: 'server',
  },

  AI_INVALID_RESPONSE: {
    title: 'Grading failed',
    message:
      "Something went wrong while checking your answer. We've been notified and are looking into it.",
    action: 'Please try again in a moment.',
    retryable: true,
    category: 'server',
  },

  AI_PARSE_ERROR: {
    title: 'Grading failed',
    message:
      "Something went wrong while processing your result. We've been notified and are looking into it.",
    action: 'Please try again in a moment.',
    retryable: true,
    category: 'server',
  },

  AI_AUTH_ERROR: {
    title: 'Service error',
    message:
      "We're having trouble with our grading service. We've been notified and are looking into it.",
    action: 'Please try again later.',
    retryable: true,
    retryAfterSeconds: 60,
    category: 'server',
  },
};
